import * as qs from 'qs';
import { AddressBookMapper } from '../AddressBookMapper.js';
import { RecipientAddressesMapper } from './RecipientAddressesMapper.js';

function paramsSerializer(parameters) {
  return qs.stringify(parameters, {
    arrayFormat: 'comma'
  });
}
class RecipientAddressesRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getWithPostalCodeInfo(_ref) {
    let {
      sort = ['alias', 'asc'],
      zipCode,
      ...rest
    } = _ref;
    return this.apiClient.get('pro/addresses/recipients/postal-code-info', {
      ...rest,
      sort,
      postal_code: zipCode
    }, undefined, paramsSerializer).then(_ref2 => {
      let {
        data
      } = _ref2;
      return {
        content: RecipientAddressesMapper.createRecipientAddressesFromResponse(data.content),
        pagination: {
          totalPages: data.total_pages,
          totalElements: data.total_elements
        }
      };
    });
  }
  delete(id) {
    return this.apiClient.delete(`pro/addresses/recipients/${id}`).then(response => response.data);
  }
  create(address) {
    return this.apiClient.post('pro/addresses/recipients', AddressBookMapper.createApiPayload(address)).then(_ref3 => {
      let {
        data
      } = _ref3;
      return {
        ...address,
        id: data.id
      };
    });
  }
  update(address) {
    return this.apiClient.put('pro/addresses/recipients', AddressBookMapper.createApiPayload(address)).then(() => address);
  }
}

export { RecipientAddressesRepository };
//# sourceMappingURL=RecipientAddressesRepository.js.map
